export default {
  '1': '番劇',
  '2': '音訊',
  '3': '遊戲中心',
  '4': '會員購',
  '5': '漫畫',
  '6': '下載APP',
  '7': '掃碼下載手機用戶端',
  '8': '創作中心',
  '9': '視頻投稿',
  '10': '音訊投稿',
  '11': '專欄投稿',
  '12': '直播歷史',
  '13': '視頻',
  '14': '視頻歷史',
  '15': '專欄',
  '16': '專欄歷史',
  '17': '全部歷史',
  '18': '註冊',
  '19': '登錄',
  '20': '登錄後妳可以',
  '21': '點我註冊',
  '22': '等級',
  '23': '答題轉正直升',
  '24': '作為',
  '25': '會員等級相關說明',
  '26': '登錄獎勵',
  '27': '綁定手機可領取每日硬幣',
  '28': '關注',
  '29': '粉絲',
  '30': '動態',
  '31': '登出',
  '32': [
    '成為正式會員，你可以：<br/>1、發射個性彈幕<br/>2、參與視頻評論<br/>3、登錄獲得硬幣<br/>4、投稿成為偶像',
    '1、發射滾動彈幕<br/>2、投稿成為偶像',
    '1、發射個性彈幕（彩色、高級）<br/>2、參與視頻互動（評論）<br/>3、投稿成為偶像',
    '1、發射個性彈幕（彩色、高級、頂部、底部）<br/>2、參與視頻互動（評論、添加tag）<br/>3、投稿成為偶像',
    '1、發射個性彈幕（彩色、高級、頂部、底部）<br/>2、參與視頻互動（評論、添加tag）<br/>3、投稿成為偶像',
    '1、購買邀請碼（1個/月）<br/>2、發射個性彈幕（彩色、高級、頂部、底部）<br/>3、參與視頻互動（評論、添加tag）<br/>4、投稿成為偶像',
    '1、購買邀請碼（2個/月）<br/>2、發射個性彈幕（彩色、高級、頂部、底部）<br/>3、參與視頻互動（評論、添加tag）<br/>4、投稿成為偶像',
  ],
  '33': '個人中心',
  '34': 'B幣錢包',
  '35': '訂單中心',
  '36': '我的店鋪',
  '37': '會員',
  '38': '主站',
  '39': '直播',
  '40': '投稿',
  '41': '投稿管理',
  '42': '直播中心',
  '43': '歷史搜尋',
  '44': '關鍵字',
  '45': '歷史',
  '46': '首頁',
  '47': '排行榜',
  '48': '好像最近沒有看過',
  '49': '稍後再看',
  '50': '語言',
  '51': '查看全部',
  '52': '播放全部',
  '53': '你可以',
  '54': '該收藏夾還沒有視頻哦~',
  '55': '首次使用',
  '56': '直播中',
  '57': '未開播',
  '58': '更早',
  '59': '精彩推薦',
  '60': '大會員可暢享各種專屬內容，還有遊戲禮包、個性裝扮等你來拿~',
  '61': '開通大會員',
  '62': '續期大會員',
  '63': '你的大會員',
  '64': '天后就要過期啦～',
  '65': '你的大會員今天過期啦～',
  '66': '你的大會員已經過期',
  '67': '天啦～',
  '68': '代金券',
  '69': '賽事',
  '70': '收藏',
  '71': '消息',
  '72': '我的課程',
  '73': '大會員',
  '74': '你無法享受特權',
  '75': '硬幣',
  '76': 'B幣',
  '77': '已綁定',
  '78': '前去綁定郵箱',
  '79': '前去綁定手機',
  '80': '頻道',
  '81': '熱門',
  '82': '貼紙投稿'
}
